import { render } from "./yos-tree.vue?vue&type=template&id=8383882e"
import script from "./yos-tree.vue?vue&type=script&lang=js"
export * from "./yos-tree.vue?vue&type=script&lang=js"

import "./yos-tree.vue?vue&type=style&index=0&id=8383882e&lang=postcss"
script.render = render

export default script